import { render, staticRenderFns } from "./room-form.vue?vue&type=template&id=3ba4f894&scoped=true"
import script from "./room-form.vue?vue&type=script&lang=js"
export * from "./room-form.vue?vue&type=script&lang=js"
import style0 from "./room-form.vue?vue&type=style&index=0&id=3ba4f894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4f894",
  null
  
)

export default component.exports